import update from 'immutability-helper';
import React from 'react';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';

class EquipmentLevelComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
  }

  /* Handle submit */
  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handlePublish(e) {
    e.preventDefault();
    this.props.onPublish();
  }

  handleUnpublish(e) {
    e.preventDefault();
    this.props.onUnpublish();
  }

  handleSave(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleFieldChange(e) {
    const newData = {
      equipmentLevel: {}
    };

    newData.equipmentLevel[e.target.name] = {
      $set: e.target.value
    };

    const props = update(this.props, newData);

    this.props.onChange(props);
  }

  render() {
    const level = this.props.equipmentLevel;
    // console.log('lvl', this.props);

    return (
      <section className="mf-equipment-level">
        <ol className="breadcrumb mf-margin-top-20">
          <li><Link to="/">Forsiden</Link></li>
          <li><Link to="/nybilinformasjon/">Nybilinformasjon</Link></li>
          <li>
            <Link to={`/modeller/${this.props.model.make.id}`}>{this.props.model.make.name}</Link>
          </li>
          <li>
            <Link to={`/modeller/${this.props.model.make.id}/modell/${this.props.model.id}`}>{this.props.model.name}</Link>
          </li>
          <li className="active">{level.name}</li>
        </ol>

        <form onSubmit={this.handleSubmit}>
          <div className="page-header">
            <div className="row">
              <div className="col-xs-12 col-sm-8">
                <h1>
                  {level.name} <PublishStatusDot entry={level} /><br/>
                  <small>Utstyrsnivå</small>
                </h1>
              </div>

              <div className="col-xs-12 col-sm-4 text-right mf-padding-top-10">
                {this.props.working &&
                  <span>&nbsp;<i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...</span>
                }
                {!level.archived &&
                  <button
                    type="submit"
                    className="btn btn-default"
                    disabled={!this.props.modified || this.props.working}
                  >
                    <span>Lagre endringer</span>
                  </button>
                }
                &nbsp;
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={!(level.draft || level.updated) || this.props.working || this.props.modified || level.archived}
                  onClick={this.handlePublish}
                >
                  <span>Publiser</span>
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-warning"
                  disabled={level.draft || this.props.working || this.props.modified}
                  onClick={this.handleUnpublish}
                >
                  <span>Avpubliser</span>
                </button>
                &nbsp;
                {!level.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={this.props.working}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onArchive();
                    }}
                  >
                    <span>Arkiver</span>
                  </button>
                }
                {level.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={this.props.working}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onUnArchive();
                    }}
                  >
                    <span>Gjenopprett</span>
                  </button>
                }
              </div>
            </div>
          </div>

          {/* Display any error message: */}
          {this.props.error &&
            <div className="alert alert-danger">
              {this.props.error}
            </div>
          }

          <div className="row">
            <div className="col-xs-12 col-md-6">
              <div className="form-group">
                <label>Navn</label>
                <div className="input-group">
                  <input type="text" className="form-control" name="name" defaultValue={level.name} disabled={!level.custom || (this.props.working || level.archived)} onChange={this.handleFieldChange}/>
                  <div className="input-group-addon">{level.custom ? '' : 'Data fra Axapta'}</div>
                </div>
              </div>
              {!level.custom &&
                <div className="form-group">
                  <label>Visningsnavn</label>
                  <input type="text" className="form-control" name="displayname" defaultValue={level.displayname} disabled={this.props.working || level.archived} onChange={this.handleFieldChange}/>
                  <span className="help-block">Faktisk navn som vises på web (eks: Intense, Invite, osv).</span>
                </div>
              }
              <div className="form-group">
                <label>Standardkonfigurerering</label>
                <input type="text" className="form-control" name="configurationId" defaultValue={level.configurationId} disabled={this.props.working || level.archived} onChange={this.handleFieldChange}/>
                <span className="help-block">Verdien brukes til å laste konfigurering når brukeren følger en utstyrnivå lenke.</span>
              </div>
            </div>
            <div className="col-xs-12 col-md-6">
              <div className="form-group">
                <label>Nivå</label>
                <div className="input-group">
                  <input type="text" required className="form-control" name="equipmentLevel" defaultValue={level.equipmentLevel} disabled={!level.custom || (this.props.working || level.archived)} onChange={this.handleFieldChange}/>
                  <div className="input-group-addon">{level.custom ? '' : 'Data fra Axapta'}</div>
                </div>
              </div>
              <div className="form-group">
                <label>Utstyrsliste</label>
                <textarea className="form-control" name="description" rows="10" defaultValue={level.description} disabled={this.props.working || level.archived} onChange={this.handleFieldChange}></textarea>
                <span className="help-block">Feltet bruker <a href="https://docs.github.com/en/github/writing-on-github/basic-writing-and-formatting-syntax" rel="noreferrer" target="_blank">Markdown</a> til formatering, men enkel HTML fungerer også. Merk: Markdown symboler må &quot;escapes&quot; om de skal brukes uten stilsetting. F.eks må * skrivers som \* for å ikke bli en punktliste.</span>
              </div>
            </div>
            <div className="col-xs-12 col-md-6">
              <div className="form-group">
                <label>Komplett utstyrsliste</label>
                <textarea className="form-control" name="descriptionFull" rows="10" defaultValue={level.descriptionFull} disabled={this.props.working || level.archived} onChange={this.handleFieldChange}></textarea>
                <span className="help-block">Verdien brukes i konfigurator for å vise full beskrivelse av utstyrsliste.</span>
                <span className="help-block">Feltet bruker <a href="https://docs.github.com/en/github/writing-on-github/basic-writing-and-formatting-syntax" rel="noreferrer" target="_blank">Markdown</a> til formatering, men enkel HTML fungerer også. Merk: Markdown symboler må &quot;escapes&quot; om de skal brukes uten stilsetting. F.eks må * skrivers som \* for å ikke bli en punktliste.</span>
              </div>
            </div>
          </div>
        </form>
      </section>
    );
  }
}

export default EquipmentLevelComponent;
